const { getAxiosInstance } = require('../connection');

module.exports = {
    generateInviteCodes: (eventId, data) =>
        getAxiosInstance({
            url: `/events/${encodeURIComponent(eventId)}/participants/actions/generate-invite-codes`,
            method: 'POST',
            data,
        }).then((r) => r.data),

    toggleFavorite: (user_id, participant_id, isFavorite = true) =>
        getAxiosInstance({
            url: `/favorite_participant${isFavorite ? '' : `/${encodeURIComponent(user_id)}`}`,
            method: isFavorite ? 'post' : 'delete',
            json: true,
            data: {
                participant_id: participant_id,
                participant_user_id: user_id,
            },
        }).then((r) => r.data),
};
